// extracted by mini-css-extract-plugin
export default {"ticker":"style_ticker__uldTa","symbolName":"style_symbolName__yaoFq"};